import React, { useLayoutEffect } from "react";
import Nav from "../Home/navbar/nav";
import Powering from "./Powering/Powering";
import Ambitiousfuture from "./Ambitiousfuture/Ambitiousfuture";
import Ourmap from "./Ourmap/Ourmap";
import Ourteam from "./Ourteam/Ourteam";
import { Helmet } from "react-helmet";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./WhoWeAre.css";

gsap.registerPlugin(ScrollTrigger);

const WhoWeAre = () => {
  useLayoutEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });

    const ctx = gsap.context(() => {

      gsap.utils.toArray(".who-we-are-animate").forEach((element, index) => {
        gsap.fromTo(
          element,
          {
            opacity: 0,
            y: 25,
          },
          {
            opacity: 1,
            y: 0,
            duration: 1.4,
            delay: index * 0.15,
            ease: "power2.out",
            scrollTrigger: {
              trigger: element,
              start: "top 90%",
              toggleActions: "play none none reverse",
            },
          }
        );
      });

      gsap.utils.toArray(".crystal-ball-animate").forEach((element) => {
        gsap.fromTo(
          element,
          {
            y: 120,
            scale: 0.7,
            opacity: 0,
            rotation: -8,
          },
          {
            y: 0,
            scale: 1,
            opacity: 1,
            rotation: 0,
            duration: 1.3,
            ease: "bounce.out",
            scrollTrigger: {
              trigger: element,
              start: "top 80%",
              toggleActions: "play none none reverse",
            },
          }
        );
      });

      gsap.utils.toArray(".map-animate").forEach((element) => {
        gsap.fromTo(
          element,
          {
            opacity: 0,
            y: 80,
            scale: 0.9,
          },
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 1.3,
            ease: "back.out(1.7)",
            scrollTrigger: {
              trigger: element,
              start: "top 80%",
              toggleActions: "play none none reverse",
            },
          }
        );
      });

    });

    return () => {
      ctx.revert();
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>Who We Are | Althi Solutions - IT Solutions & Services</title>
        <link
            rel="preload"
            as="image"
            href="/src/Media/mesh-gradient.jpg"
          />
        <meta
          name="description"
          content="A skilled team of developers, designers, and consultants who provide crafted solutions that bring your ideas to life."
        />
        <link
          rel="canonical"
          href="https://www.althisolutions.com/whoWeAre"
        />
        <meta name="robots" content="index, follow" />

        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Who We Are | Althi Solutions - IT Solutions & Services"
        />
        <meta
          property="og:description"
          content="A skilled team of developers, designers, and consultants who provide crafted solutions that bring your ideas to life."
        />
        <meta
          property="og:url"
          content="https://www.althisolutions.com/whoWeAre"
        />
        <meta
          property="og:image"
          content="https://www.althisolutions.com/thumbnail.jpg"
        />
        <meta property="og:site_name" content="Althi Solutions" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:site"
          content="@AlthiSolutions"
        />
        <meta
          name="twitter:creator"
          content="@AlthiSolutions"
        />
        <meta
          name="twitter:title"
          content="Who We Are | Althi Solutions - IT Solutions & Services"
        />
        <meta
          name="twitter:description"
          content="A skilled team of developers, designers, and consultants who provide crafted solutions that bring your ideas to life."
        />
        <meta
          name="twitter:image"
          content="https://www.althisolutions.com/thumbnail.jpg"
        />
      </Helmet>

      <Nav />
      <Powering />
      <Ourteam />
      <Ambitiousfuture />
      <Ourmap />
    </>
  );
};

export default WhoWeAre;